import { endOfDay, startOfDay, startOfMonth, subDays, subMonths } from 'date-fns'

import { TimePeriod } from 'components/reports/Metrics/constants/ExceptionMetrics'
import { SupplierActivationPeriod } from 'components/reports/Metrics/constants/SupplierActivation'

import { DateInterval } from './date.helpers'

export const resolvePeriod = (period: TimePeriod): DateInterval => {
  const now = new Date()
  switch (period) {
    case 'last7':
      return { start: startOfDay(subDays(now, 6)), end: endOfDay(now) }
    case 'last90':
      return { start: startOfDay(subDays(now, 89)), end: endOfDay(now) }
    case 'thisMonth':
      return { start: startOfMonth(now), end: endOfDay(now) }
    case 'lastMonth': {
      const lastMonth = subMonths(now, 1)
      return { start: startOfMonth(lastMonth), end: endOfDay(subDays(startOfMonth(now), 1)) }
    }
    case 'last30':
    default:
      return { start: startOfDay(subDays(now, 29)), end: endOfDay(now) }
  }
}

export const resolveSupplierActivationPeriod = (period: SupplierActivationPeriod): DateInterval => {
  const now = new Date()

  switch (period) {
    case 'last6months':
      return { start: startOfDay(subMonths(now, 6)), end: endOfDay(now) }
    case 'last12months':
      return { start: startOfDay(subMonths(now, 12)), end: endOfDay(now) }
    case 'custom':
      return resolvePeriod('last90')
    default:
      return resolvePeriod(period)
  }
}
